import { tns } from 'tiny-slider/src/tiny-slider';
import { Component } from '../core/component';

export class TileWall extends Component {
    constructor() {
        super();
        this.selector = '[data-tilewall]';
    }

    init() {
        const carousels = document.querySelectorAll(this.selector);

        function getIcon(id) {
            return `<svg viewBox="0 0 1 1" class="iconography" size="" color="currentColor" aria-hidden="true">
            <use xlink:href="${global.$app.siteUrl}/assets/sprite/icons-sprites.svg#${id}"></use>
          </svg>`;
        }

        carousels.forEach((carousel) => {
            tns({
                container: carousel,
                autoplay: false,
                autoWidth: true,
                rewind: false,
                items: 1,
                controls: true,
                nav: false,
                mouseDrag: true,
                loop: false,
                controlsText: [
                    `${getIcon('arrow-long-left')} <span class="hide-visually">Previous slide</span>`,
                    `${getIcon('arrow-long-right')} <span class="hide-visually">Next slide</span>`,
                ],
            });
        });
    }
}
